// extracted by mini-css-extract-plugin
module.exports = {"root":"Main_root__QMQUx","bg":"Main_bg__dpBgx","title":"Main_title__W3Uie"};